import { render, staticRenderFns } from "./BasePopup.vue?vue&type=template&id=1ff8053a&scoped=true"
import script from "./BasePopup.vue?vue&type=script&lang=ts"
export * from "./BasePopup.vue?vue&type=script&lang=ts"
import style0 from "./BasePopup.vue?vue&type=style&index=0&id=1ff8053a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff8053a",
  null
  
)

export default component.exports